module.exports = __webpack_public_path__ + "img/gem.80afa9e8.png";